import {
  Component,
  OnInit,
  ViewContainerRef,
  ViewChild,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, FormsModule } from "@angular/forms";
import { FormUtil } from "../../../utils/formutils";
import { AccountantService } from "./accountant.service";
import { GeneralUtil } from "../../../utils/general";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { HotToastService } from "@ngneat/hot-toast";
import { AddAccountantModalComponent } from "./modals/addAccountantModal.component";
import { EditAppsModalComponent } from "../common/modals/edit-apps-modal.component";
import { AddAppsModalComponent } from "../accountant/modals/add-apps-modal.component";
import { OpenAppModalComponent } from "../common/modals/open-app-modal.component";
import { AddAppsModalService } from "./modals/add-apps-modal.service";
import { EditAppsModalService } from "../common/modals/edit-apps-modal.service";
import { AppSearchPipe } from "../common/apps.pipes";
import { ResourcesPageComponent } from "./resources-page.component";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgClass, NgIf, NgFor } from "@angular/common";

declare var jQuery: any;

/**
 * Dashboard main page component. It's empty for now
 */
@Component({
    selector: "apps-page",
    templateUrl: "./apps-page.component.html",
    styleUrls: [],
    imports: [
        FormsModule,
        NgClass,
        NgIf,
        NgFor,
        TooltipModule,
        ResourcesPageComponent,
        AppSearchPipe,
    ]
})
export class AppsPageComponent implements OnInit {
  @ViewChild("logoInput") logoInput: ElementRef;
  @ViewChild("logoImage") logoImage: ElementRef;

  bsModalRef: BsModalRef;
  public modalRef: BsModalRef;
  template_add = AddAppsModalComponent;
  template_edit = EditAppsModalComponent;
  company: any = {};
  practiceInfoForm: UntypedFormGroup;
  formUtil: FormUtil;
  showAddApp: any;

  // Store global resources from /resource when ACCOUNTANT
  global_apps: any = [];

  // Store company specific resources from /resource when ACCOUNTANT
  practice_apps: any = [];

  // Fixed copy for sorting purposes
  fixed_global_apps: any = [];

  used_apps: any = [];
  search = "";

  current_library = { name: "Practice Library", bucket: this.practice_apps };

  constructor(
    private localStorage: LocalStorageService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    private modalService: BsModalService,
    private accountantService: AccountantService,
    private addAppsModalService: AddAppsModalService,
    private editAppsModalService: EditAppsModalService
  ) {}

  ngOnInit(): void {
    this.accountantService.get_practice_apps().then((res) => {
      const response = res;
      this.global_apps = response.global_apps;
      this.practice_apps = response.practice_apps;
      this.fixed_global_apps = response.global_apps;
      this.used_apps = response.used_apps;

      this.current_library.bucket = this.practice_apps;
    });

    this.editAppsModalService.delete.subscribe((sub) => {
      // console.log('deleted app', sub);

      this.practice_apps = this.practice_apps.filter((app) => {
        return app.id != sub;
      });

      this.current_library.bucket = this.practice_apps;
    });
  }

  public openModal(event, template, app = null) {
    // event.stopPropagation();

    if (app != null) {
      if (app.company == null) {
        window.open(app.url, "_blank");
        return;
      }
    }

    console.log(template === this.template_add);

    if (template === this.template_add) {
      this.modalService.onHide.subscribe((reason: string) => {
        if (this.addAppsModalService.app !== null) {
          this.practice_apps.push(this.addAppsModalService.app);
          this.addAppsModalService.app = null;
        }
      });
    }

    if (template === this.template_edit) {
      this.modalService.onHide.subscribe((reason: string) => {
        console.log(this.editAppsModalService.app);
        if (
          this.editAppsModalService.app !== null &&
          this.editAppsModalService.app !== undefined
        ) {
          for (let x = 0; x < this.current_library.bucket.length; x++) {
            if (
              this.current_library.bucket[x].id ===
              this.editAppsModalService.app.id
            ) {
              this.current_library.bucket[x] = this.editAppsModalService.app;
              break;
            }
          }

          for (let x = 0; x < this.used_apps.length; x++) {
            if (this.used_apps[x].id === this.editAppsModalService.app.id) {
              this.used_apps[x] = this.editAppsModalService.app;
              break;
            }
          }

          this.editAppsModalService.app = null;
        }
      });
    }

    this.bsModalRef = this.modalService.show(template, { class: "modal-lg" });
    // this.bsModalRef.content.app = app;
    if (template === EditAppsModalComponent) {
      this.bsModalRef.content.ngOnChanges({ app: app });
    }
  }

  change_library(type): void {
    if (type === "global") {
      this.current_library.bucket = this.global_apps;
      this.current_library.name = "Global Library";
    } else if (type === "practice") {
      this.current_library.bucket = this.practice_apps;
      this.current_library.name = "Practice Library";
    }
  }

  openOpenAppModal(app): void {
    // if (app.vault !== null) {
    //   if (app.vault.username === '' || app.vault.password === '') {
    //     window.open(app.url, '_blank');
    //   } else {
    //     this.modalRef = this.modalService.show(OpenAppModalComponent, {class: 'modal-lg'});
    //     this.modalRef.content.ngOnChanges({app: app});
    //   }
    // } else {
    window.open(app.url, "_blank");
    // }
  }
}
